import { ReactNode } from "react";
import { useAssessmentSession } from "../contexts/assessmentUserContext";
import { Navigate } from "react-router-dom";

export function SuperAdminRoute({ children }: { children: ReactNode }) {
  const { isActualSuperAdmin } = useAssessmentSession();

  if (!isActualSuperAdmin) {
    console.error("User is not a super admin");
    return <Navigate to="/reading" replace />;
  }

  return children;
}
